import React from "react";
import { Layout } from "antd";
import Leads from "../../containers/leads";
import Navbar from "../../components/navbar";
import "./styles.css";

const { Header, Footer, Content } = Layout;

function index(props) {
  return (
    <div>
      <Layout>
        <Header>
          <Navbar />
        </Header>
        <Content>
          <Leads />
        </Content>
        <Footer>Footer</Footer>
      </Layout>
    </div>
  );
}

export default index;
